import { Action, Level, PermissionOutput, PermissionScope } from '@app/models/users';
import { stringToBoolean } from '@app/services/stringToBoolean';

/** Порядок разделов для таблицы «что даёт роль» и сводки (по макету). */
const SCOPE_DISPLAY_ORDER: PermissionScope[] = [
  PermissionScope.Orders,
  PermissionScope.Products,
  PermissionScope.Catalogs,
  PermissionScope.RecipientsAndContacts,
  PermissionScope.Users,
  PermissionScope.Roles,
  PermissionScope.UserGroups,
  PermissionScope.OrderApprovalChains,
  PermissionScope.Processes,
  PermissionScope.Assignments,
  PermissionScope.Warehouses,
  PermissionScope.Account,
  PermissionScope.Imports,
  PermissionScope.Analytics,
  PermissionScope.Epd,
];

/**
 * Уровень раздела для роли по конкретному действию (по умолчанию «просмотр»).
 * Уровень «просмотр» определяет область видимости; «управление» — право create/edit/revoke.
 */
export const getScopeLevel = (
  permissions: PermissionOutput[] | undefined,
  scope: PermissionScope,
  action: Action = Action.View
): Level => {
  const perm = permissions?.find((p) => p.permission_scope === scope);
  const rule = perm?.rules?.find((r) => r.action === action);
  return rule?.level || Level.Denied;
};

interface GrantedScope {
  scope: PermissionScope;
  level: Level;
}

/** Разделы, где роль даёт больше, чем «Запрещено», в порядке отображения. */
export const getGrantedScopes = (permissions: PermissionOutput[] | undefined): GrantedScope[] =>
  SCOPE_DISPLAY_ORDER.map((scope) => ({ scope, level: getScopeLevel(permissions, scope) })).filter(
    (g) =>
      g.level !== Level.Denied &&
      (g.scope !== PermissionScope.Epd || stringToBoolean(process.env.REACT_APP_FEATURE_EPD))
  );
